import React from 'react';
import moment from 'moment';
import { defineMessages, FormattedMessage } from 'react-intl';

const messages = defineMessages({
  SubtractOneMonth: '-1 month',
  AddOneMonth: '+1 month',
  PreviousMonth: 'Previous month',
  CurrentMonth: 'Current month',
});

function AbsenceCalendarPeriods({ filters = {}, onChangeDate }) {
  const { year, month } = filters;
  const currentMonth = moment.utc().startOf('month');

  const navigateMonth = (offset) => {
    const currentDate = moment.utc({ year, month, day: 1 });
    const newDate = currentDate.add(offset, 'months');
    onChangeDate({ year: newDate.year(), month: newDate.month() });
  };

  const goToPreviousMonth = () => {
    const prevMonth = moment.utc().subtract(1, 'month');
    onChangeDate({ year: prevMonth.year(), month: prevMonth.month() });
  };

  const goToCurrentMonth = () => {
    onChangeDate({ year: moment.utc().year(), month: moment.utc().month() });
  };

  return (
    <div className="form-group">
      <div className="btn-group btn-group-justified">
        <button
          type="button"
          className="btn btn-default"
          onClick={() => navigateMonth(-1)}
        >
          <FormattedMessage {...messages.SubtractOneMonth} />
        </button>
        <button
          type="button"
          className="btn btn-default"
          onClick={goToPreviousMonth}
        >
          <FormattedMessage {...messages.PreviousMonth} />
        </button>
        <button
          type="button"
          className="btn btn-default"
          onClick={goToCurrentMonth}
        >
          <FormattedMessage {...messages.CurrentMonth} />
        </button>
        <button
          type="button"
          className="btn btn-default"
          onClick={() => navigateMonth(1)}
        >
          <FormattedMessage {...messages.AddOneMonth} />
        </button>
      </div>
    </div>
  );
}

export default AbsenceCalendarPeriods;
